function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.33808 6.49978L10.827 4.01063C10.827 4.01063 10.8287 4.01063 10.8287 4.0089L12.6191 2.21831C13.127 1.71042 13.127 0.888796 12.6191 0.380913C12.1113 -0.126971 11.288 -0.126971 10.7802 0.380913L9.88757 1.27361C9.88584 1.27534 9.88584 1.27534 9.88584 1.27534L6.49913 4.66066L2.21982 0.380913C1.71199 -0.126971 0.888707 -0.126971 0.380875 0.380913C-0.126958 0.888796 -0.126958 1.71042 0.380875 2.21831L4.66192 6.49978L0.380875 10.7813C-0.126958 11.2891 -0.126958 12.1108 0.380875 12.6187C0.635658 12.8735 0.968435 13 1.29948 13C1.63226 13 1.96504 12.8735 2.21982 12.6187L6.49913 8.33891L10.7802 12.6187C11.035 12.8735 11.3677 13 11.6988 13C12.0316 13 12.3643 12.8735 12.6191 12.6187C13.127 12.1108 13.127 11.2891 12.6191 10.7813L8.33808 6.49978Z",
  fill: "#C7C7C7"
});

function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.41a3ed6c.svg";
export { ForwardRef as ReactComponent };